module.exports = __webpack_public_path__ + "img/742.295210da.png";